import { Sanitize } from '../../Sanitize/Sanitize';
import Tag from '../Components/Tag';
import Switch from '../Components/Switch';

import { makeText } from '../../../util';

export const VendorContent = ({
  vendor,
  settings,
  language,
  dev,
  accordionOpen,
  toggleVendor,
  usePurModel,
}) => {
  const cookieText = makeText(Boolean(dev), settings, 'cookieText', language);
  const tableCategoryText = makeText(Boolean(dev), settings, 'tableCategoryText', language);
  const tableCookieText = makeText(Boolean(dev), settings, 'tableCookieText', language);
  const tableDomainText = makeText(Boolean(dev), settings, 'tableDomainText', language);
  const tableDurationText = makeText(Boolean(dev), settings, 'tableDurationText', language);

  // IAB Categories
  const iabConsent = makeText(Boolean(dev), settings, 'iabConsent', language);
  const iabLegInt = makeText(Boolean(dev), settings, 'iabLegInt', language);
  const iabFeatures = makeText(Boolean(dev), settings, 'iabFeatures', language);
  const iabSpecialFeatures = makeText(Boolean(dev), settings, 'iabSpecialFeatures', language);
  const iabSpecialPurposes = makeText(Boolean(dev), settings, 'iabSpecialPurposes', language);
  return (
    <div className="vendor-content">
      {vendor.description && (
        <p className="pm-sub-p" dangerouslySetInnerHTML={{ __html: Sanitize({ html: vendor.description }) }} />
      )}
      {vendor.cookieHeader && (
        <div className="vendor-cookie-header">{vendor.cookieHeader}</div>
      )}
      <Tag vendor={vendor} tabbable={accordionOpen} />
      <div>
        {vendor.consentCategories.length > 0 && (
          <div className="vendor-info">
            <div className="vendor-header-container">
              <h3>{iabConsent}</h3>
              <div>
                <Switch
                  consentType="consent"
                  child="vendors"
                  value={vendor}
                  checked={vendor.active}
                  toggle={toggleVendor}
                  dev={dev}
                  settings={settings}
                  language={language}
                  usePurModel={usePurModel}
                />
              </div>
            </div>
            {vendor.consentCategories.map(c => <div>&#8226; {c.name || c}</div>)}
          </div>
        )}
        {vendor.legIntCategories.length > 0 && (
          <div className="vendor-info">
            <div className="vendor-header-container">
              <h3>{iabLegInt}</h3>
              <div>
                <Switch
                  consentType="legInt"
                  child="vendors"
                  value={vendor}
                  checked={vendor.legInt}
                  toggle={toggleVendor}
                  dev={dev}
                  settings={settings}
                  language={language}
                />
              </div>
            </div>
            {vendor.legIntCategories.map(c => <div>&#8226; {c.name || c}</div>)}
          </div>
        )}
        {vendor.iabFeatures.length > 0 && (
          <div className="vendor-info">
            <h3>{iabFeatures}</h3>
            {vendor.iabFeatures.map(c => <div>&#8226; {c.name || c}</div>)}
          </div>
        )}
        {vendor.iabSpecialFeatures.length > 0 && (
          <div className="vendor-info">
            <h3>{iabSpecialFeatures}</h3>
            {vendor.iabSpecialFeatures.map(c => <div>&#8226; {c.name || c}</div>)}
          </div>
        )}
        {vendor.iabSpecialPurposes.length > 0 && (
          <div className="vendor-info">
            <h3>{iabSpecialPurposes}</h3>
            {vendor.iabSpecialPurposes.map(c => <div>&#8226; {c.name || c}</div>)}
          </div>
        )}
      </div>
      {vendor.cookies.length > 0 && (
        <div className="vendor-cookies">
          <div className="cookie-title">{cookieText}</div>
          <table className="tvtbl">
            <tr>
              <th>{tableCategoryText}</th>
              <th>{tableCookieText}</th>
              <th>{tableDomainText}</th>
              <th>{tableDurationText}</th>
            </tr>
            {vendor.cookies.map((c) => (
              <tr>
                <td className="category-td no-content">{c.categoryName}</td>
                <td><span className="cookie-td">{c.name}</span></td>
                <td className="no-content">{c.domain}</td>
                <td><span>{c.cookieLifeSpan}</span></td>
              </tr>
            ))}
          </table>
        </div>

      )}
    </div>
  );
};